module.exports = __webpack_public_path__ + "media/images/partners/africa-development-universalis-c2cc5090ed3f46f347a24353dc06e9e6.png";